<template>
	<transition name="fade">
		<div class="paperBag" v-show='visiable'>
			<div class="bag">
				<div class="bag-content">
					<div class="bag-header">
						<p>
							<span>長按保存</span>
						</p>
					</div>
					<div class="bag-body">
						<div id='captureId' style="text-align:center;">
							<div class="loadImg" v-show="firstFlag">
								<loading />
							</div>
							<div class="mask" v-show="firstFlag">
								<div style="padding-top:65%;padding-left:40px;padding-right:20px;line-height: 30px;position: absolute;height: 100%;width: 100%;font-size: 16px;text-align: left;">尊敬的{{name}}，
									<p style="text-indent: 40px;">在您生日之際，小dō 誠摯地祝福您生日快樂！願大地的禮物能帶給您無限的芬芳與幸福！
										<p />
									<p style="text-align: right;margin-top: 70px;">----小dō敬上</p>
								</div>
							</div>
							<img class="show-img" v-show="!firstFlag" :src="dataURL">

						</div>
					</div>

					<!-- <div class="bag-footer">
						<Button type="primary" :disabled='firstFlag' size="large" long @click="download">下載(download)</Button>
					</div> -->
				</div>

			</div>

		</div>
	</transition>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import domtoimage from "dom-to-image";
import loading from "@/components/order/loading";
export default {
	data() {
		return {
			visiable: true,

			firstFlag: true,
			dataURL: "",
			imgHegiht: 0,
            loadImg: false,
            name:null
		};
	},
	watch: {
		value(val) {
			this.visiable = val;
			if (val) {
				this.initData(this.pic);
			}
		},
	},
	mounted() {
		this.$nextTick(function () {
            var name= this.$route.query.name
            if(name){
                 this.name=name
                 this.initData('http://doc.doterra.cn/uploads/cvo/static/birthday1.jpg');
            }   
        });
	},
	methods: {
		async initData(url) {
			var res = await this.$loadImage(url);
			if (res) {
				window.pageYOffset = 0;
				document.documentElement.scrollTop = 0;
				document.body.scrollTop = 0;
				res.classList.add("canvas-img");
				await this.sleep(500);
				document.querySelector(".mask").appendChild(res);
				var dom = document.querySelector("#captureId .mask");

				var res = await domtoimage.toPng(dom);
				if (res) {
					this.dataURL = res;
				}
			}
			this.firstFlag = false;
			this.loadImg = false;
		},
		getBase64Image(img) {
			var canvas = document.createElement("canvas");
			canvas.width = img.width;
			canvas.height = img.height;
			var ctx = canvas.getContext("2d");
			ctx.drawImage(img, 0, 0, img.width, img.height);
			var dataURL = canvas.toDataURL("image/png");
			return dataURL;
		},
		downloadIamge(imgsrc, name) {
			//下載圖片地址和圖片名
			var image = new Image();
			// 解決跨域 Canvas 汙染問題
			image.setAttribute("crossOrigin", "anonymous");
			image.onload = function () {
				var canvas = document.createElement("canvas");
				canvas.width = image.width;
				canvas.height = image.height;
				var context = canvas.getContext("2d");
				context.drawImage(image, 0, 0, image.width, image.height);
				var url = canvas.toDataURL("image/png"); //得到圖片的base64編碼數據

				var a = document.createElement("a"); // 生成一個a元素
				var event = new MouseEvent("click"); // 創建一個單擊事件
				a.download = name || "photo"; // 設置圖片名稱
				a.href = url; // 將生成的URL設置為a.href屬性
				a.dispatchEvent(event); // 觸發a的單擊事件
			};
			image.src = imgsrc;
		},
		download() {
			this.downloadIamge(this.dataURL,'下載')
			// console.log("this.dataURL", this.dataURL);
			// var a = document.createElement("a");
			// a.href = this.dataURL;
			// a.download = name;
			// a.click();
		},
		colse() {
			this.$emit("close");
			this.firstFlag = true;
			this.loadImg = true;
			var box = document.querySelector(".canvas-img");
			box.remove();
		},
		async confirm() {},
	},
	components: {
		loading,
	},
};
</script>
<style lang='scss' scoped>
@media screen and (max-width: 768px) {
	.paperBag #captureId .mask > b {
		font-size: 14px;
		top: 14%;
	}
	.paperBag #captureId .mask > span {
		font-size: 12px;
	}

	img.show-img {
		width: 100%;
	}
	.paperBag .bag {
		width: 100%;
	}
}
.paperBag {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(55, 55, 55, 0.6);
	height: 100%;
	z-index: 20000;
	overflow-y: scroll;
}
.bag {
	width: 520px;
	top: 20px;
	margin: 0 auto;
	position: relative;
	outline: none;
}
.bag-content {
	position: relative;
	//background-color: #fff;
	border: 0;
	border-radius: 6px;
	background-clip: padding-box;
}
.close {
	font-size: 32px;
	position: absolute;
	right: 16px;
	top: 8px;
	overflow: hidden;
	cursor: pointer;
}
.bag-header {
	//border-bottom: 1px solid #e9eaec;
	padding: 14px 16px;
	line-height: 1;
	p {
		display: inline-block;
		width: 100%;
		height: 20px;
		line-height: 20px;
		font-size: 22px;
		font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		color: white;
		text-align: center;
	}
}
.bag-body {
	padding: 16px;
	font-size: 12px;
	line-height: 1.5;
}
.bag-footer {
	border-top: 1px solid #e9eaec;
	padding: 12px 18px 12px 18px;
	text-align: right;
}
.canvas-img {
	display: block;
	max-width: 100%;
	height: auto;
}
.show-img {
	width: 70%;
	height: auto;
}
#captureId {
	position: relative;
	min-height: 350px;
	.loadImg {
		position: absolute;
		width: 100%;
		height: 100%;
		text-align: center;
		z-index: 200;
		background-color: white;
	}
	.mask {
		position: relative;
		overflow: hidden;
		& > b {
			position: absolute;
			text-align: center;
			color: white;
			width: 100%;
			left: 0;
			text-align: center;
			top: 21%;
			font-weight: 500;
			font-size: 25px;
		}
		& > span {
			top: 1%;
			font-size: 16px;
			font-weight: 500;
			position: absolute;
			right: 2%;
			color: white;
		}
	}
}
</style>